// extracted by mini-css-extract-plugin
module.exports =  {"nowrap":"_35875ce240--nowrap--QbNay","wrap":"_35875ce240--wrap--UqD6F"};